const env_var = process.env;

export const BASE_URL =
  env_var.REACT_APP_ENVIRONMENT === "production"
    ? env_var.REACT_APP_PROD_BASE_URL
    : env_var.REACT_APP_DEV_BASE_URL;
